import { useNavigate } from "react-router-dom";

export type UseOpenProjectHookProps = {
    openProject: (projectId: string) => void 
};

export const useOpenProject = () : UseOpenProjectHookProps => {
    const navigate = useNavigate();

    const openProjectHandler = (projectId: string) : void => {
        navigate(`../projects?projectId=${projectId}`, { relative: 'path' });
    };

    return { openProject: openProjectHandler };
};